import React, { useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import DOMPurify from 'dompurify';
import { translate } from '../Services/translation';

const ProductInformationTabs = (props) => {
  const {
    productInformation,
    longdescription,
    technical,
    accessories,
    spareparts,
    manuals,
    media,
    isLoncin
  } = props;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const showGeneralInformation = productInformation || longdescription;

  const ariaProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  const cleanHtml = (dirtyHTML) => {
    var cleaned = DOMPurify.sanitize(dirtyHTML, { ADD_TAGS: ["iframe"], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'] }, {
      USE_PROFILES: { html: true, },
    });
    return cleaned;
  };

  const columnClass = media.length > 2 ? 'small-12' : 'small-12 large-6';

  useEffect(() => {
    const placeholder = document?.querySelector(".product-information__tabs-placeholder");
    if(placeholder){
        placeholder.remove();
    }
},[])

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          TabIndicatorProps={{ style: { background: `${isLoncin ? '#E94F25' : '#F9BD08'}`} }}
          value={value}
          onChange={handleChange}
          aria-label="Product Information"
        >
          {showGeneralInformation && (
            <Tab
              value={0}
              icon={<div className="icon-information"></div>}
              label={translate('productpage.info')}
              {...ariaProps(0)}
            />
          )}
          {technical && technical.length > 0 && (
            <Tab
              value={1}
              icon={<div className="icon-technical"></div>}
              label={translate('productpage.technical')}
              {...ariaProps(1)}
            />
          )}
          {media &&  media.length > 0 && (
            <Tab
              value={2}
              icon={<div className="icon-videos"></div>}
              label={translate('productpage.videos')}
              {...ariaProps(2)}
            />
          )}
          {accessories && accessories.length > 0 && (
            <Tab
              value={3}
              icon={<div className="icon-package"></div>}
              label={translate('productpage.accessories')}
              {...ariaProps(3)}
            />
          )}
          {spareparts && spareparts.length > 0 && (
            <Tab
              value={4}
              icon={<div className="icon-spare-parts"></div>}
              label={translate('productpage.spareparts')}
              {...ariaProps(4)}
            />
          )}         
          {manuals && manuals.length > 0 && (
            <Tab
              value={5}
              icon={<div className="icon-pdf"></div>}
              label={translate('productpage.manuals')}
              {...ariaProps(5)}
            />
          )}
        </Tabs>
      </Box>
      {showGeneralInformation && (
        <TabPanel value={value} index={0}>
          {longdescription && (
            <div
              className="filter-modal__long-description"
              dangerouslySetInnerHTML={{ __html: cleanHtml(longdescription) }}
            ></div>
          )}
          {productInformation &&
            productInformation.map((info) => (
              <>
                {info.Title && info.Text && (
                  <div
                    className="faq-block__item"
                    data-title={info.Title}
                    data-text={info.Text}
                  ></div>
                )}
              </>
            ))}
        </TabPanel>
      )}
      {technical && (
        <TabPanel value={value} index={1}>
          <div className="product-page__tabs__field-list">
            {technical.map((spec, i) => (
              <div key={'tech-' + i} className="small-12">
                <span className="small-6 caption-4">{spec.ViewName}</span>
                <span className="small-6" dangerouslySetInnerHTML={{__html: cleanHtml(spec.Value)}}></span>
              </div>
            ))}
          </div>
        </TabPanel>
      )}
      {media && (
        <TabPanel value={value} index={2}>
          <div className="product-page__videos-container">
            <div className="product-page__videos-wrapper">
              {media.map((video, i) => (
                <div
                  key={'video-' + i}
                  className={
                    'product-page__videos-wrapper--videos ' +
                    columnClass +
                    ' columns'
                  }
                >
                  <div
                    className="video__embeded"
                    dangerouslySetInnerHTML={{ __html: video }}
                  ></div>
                </div>
              ))}
            </div>
          </div>
        </TabPanel>
      )}
      {accessories && (
        <TabPanel value={value} index={3}>
          {accessories.length > 0 && (
            <ul className="row-products">
              {accessories.map((accessory, i) => (
                <li
                  key={'accessory-' + i}
                  className="columns small-6 medium-4 large-3 product__container"
                  dangerouslySetInnerHTML={{
                    __html: cleanHtml(accessory.children[0]),
                  }}
                ></li>
              ))}
            </ul>
          )}
        </TabPanel>
      )}
      {spareparts && (
        <TabPanel value={value} index={4}>
          {spareparts.length > 0 && (
            <ul className="row-products">
              {spareparts.map((sparepart, i) => (
                <li
                  key={'spare-' + i}
                  className="columns small-6 medium-4 large-3 product__container"
                  dangerouslySetInnerHTML={{
                    __html: cleanHtml(sparepart.children[0]),
                  }}
                ></li>
              ))}
            </ul>
          )}
        </TabPanel>
      )}
      {manuals && (
        <TabPanel value={value} index={5}>
          <div className="product-page__tabs__manual-container">
            {manuals.map((manual, i) => (
              <div
                key={'tabmanual-' + i}
                className="product-page__tabs__manual"
              >
                <div className="icon-pdf"></div>
                <a href={manual.Url} target="_blank">
                  {manual.Filename}
                </a>
              </div>
            ))}
          </div>
        </TabPanel>
      )}
    </Box>
  );
};

export default ProductInformationTabs;
